(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('ReasonService', ReasonService);

  ReasonService.$inject = ['$resource'];

	 function ReasonService ($resource) {
    return $resource(apiUrl + '/reason-pause/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      getReasonPause: { url: apiUrl + '/reason-pause/list-reason-pause', method: 'GET', params: {}, isArray: true },
      paged: { url: apiUrl + '/reason-pause/paged', method: 'GET', params: {}, isArray: false },
      getTypes: { url: apiUrl + '/reason-pause/get-types', method: 'GET', params: {}, isArray: true }
    });
  }
})();
